
export enum CityImprovementTypes {
    Trade = 0,
    Politics = 1,
    Science = 2,
}
